module.exports = "pegasus/assets/blocks/header-9-tech.png";